<script>
/**
 * 公共事業場補完モーダル
 */
import {mapActions} from "vuex";
import PublicPlaceSearchModal from "./PublicPlaceSearchModal.vue";
import PublicPlaceAddModal from "./PublicPlaceAddModal.vue";

export default {
  name: "PublicPlaceComplementModal",
  components: {
    PublicPlaceSearchModal,
    PublicPlaceAddModal
  },
  props: {
    dialog: {
      type: Boolean,
      default: () => false
    },
    selectableIds: {
      type: Array,
      default: () => []
    },
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  watch: {
    dialog(val) {
      this.public_places = []
      this.selectableId = null;
      this.selectableItem = null;
      if (val) {
        this.searchPublicPlaces();
      }
    }
  },
  created() {
  },
  data () {
    return {
      page: 1,
      totalVisible: 7,
      targetId: null,
      searchPublicPlace: false,
      addPublicPlace: false,
      tableHeader: [
        { text: 'マニフェスト\r\n区間', value: 'manifest_no', sortable: false, align: "center", width: "15%" },
        { text: '公共積替\r\n住所', value: 'jwnet_trader_location_name', sortable: false, width: "25%" },
        { text: 'DXE事業場コード', value: 'trader_location_code', sortable: false, width: "15%" },
        { text: 'DXE公共積替事業場\r\nDXE住所', value: 'dxe_trader_location_name', sortable: false, width: "25%" },
        { text: "", value: "actions", sortable: false, align: "end", width: "20%" }
      ],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      /* 一覧情報 */
      public_places: [],
      /* 選択・新規登録ボタンを押下した行のJWNETマニフェストID */
      selectableId: null,
      selectableManifestId: null,
      /* 選択・新規登録ボタンを押下した行のJWNETマニフェスト */
      selectableItem: null,
    }
  },
  methods: {
    ...mapActions('DriverTransferPublicPlaceComplement', {
      fetchPublicPlaceComplements: 'index'
    }),
    /**
     * 検索
     */
    searchPublicPlaces () {
      let params = {
        jwnet_manifest_ids: this.selectableIds.join(','),
        page: this.page,
      }
      this.fetchPublicPlaceComplements({params: params}).then((content) => {
        this.public_places = content.public_place_complements
        this.pagination = content.pagination
      })
    },
    pageChangeEvent () {
      this.searchPublicPlaces()
    },
    /**
     * 選択ボタン クリックイベント
     * 公共積替の選択モーダルを表示する.
     */
    selectButtonClickEvent (item) {
      this.selectableItem = item;
      this.searchPublicPlace = true;
    },
    /**
     * 新規登録ボタン クリックイベント
     * 公共積替の新規登録モーダルを表示する.
     */
    addButtonClickEvent (item) {
      this.selectableId = item.id
      this.selectableManifestId = item.ma_jwnet_manifest_id
      this.addPublicPlace = true;
    },
    /**
     * 閉じるボタン クリックイベント
     * 閉じることを呼び出しもとに伝達
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 選択・登録画面の閉じる
     */
    closeModalCallback () {
      this.searchPublicPlace = false;
      this.addPublicPlace = false;
    },
    /**
     * 選択画面で登録を行なって戻ってきた時
     */
    publicPlaceSearchCallback () {
      this.searchPublicPlaces();
      this.$emit("registerCallback");
      this.closeModalCallback();
    },
  }
}
</script>

<template>
  <div>
    <v-dialog
      :value="dialog"
      scrollable
      width="1500"
      @click:outside="closeButtonClickEvent"
      @close="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>
            公共事業場データ補完
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-title class="primary--text">
          公共事業場
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="tableHeader"
            :items="public_places"
            :items-per-page="-1"
            hide-default-footer
            disable-sort
          >
            <template v-slot:[`item.manifest_no`]="{ item }">
              <div>{{ item.manifest_no }}</div>
              <div>区間{{ item.section_no }}運搬先</div>
            </template>
            <template v-slot:[`item.jwnet_trader_location_name`]="{ item }">
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.jwnet_trader_location_name"
                style="width: 300px;"
              >{{ item.jwnet_trader_location_name }}</div>
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.jwnet_trader_location_address"
                style="width: 300px;"
              >{{ item.jwnet_trader_location_address }}</div>
            </template>
            <template v-slot:[`item.trader_location_code`]="{ item }">
              <div>
                {{ item.dxe_trader_location_code }}
              </div>
              <div>
                <v-chip
                  :title="item.linked ? 'マスタ紐付け済' : '紐付け未設定'"
                  label
                  x-small
                  :color="item.linked ? 'info' : 'error'"
                >
                  {{ item.linked ? 'マスタ紐付け済' : '紐付け未設定' }}
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.dxe_trader_location_name`]="{ item }">
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.dxe_trader_location_name"
                style="width: 300px;"
              >{{ item.dxe_trader_location_name }}</div>
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.dxe_trader_location_address"
                style="width: 300px;"
              >{{ item.dxe_trader_location_address }}</div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                color="primary"
                small
                @click="selectButtonClickEvent(item)"
              >
                紐付け
              </v-btn>&emsp;
              <v-btn
                color="primary"
                small
                @click="addButtonClickEvent(item)"
              >
                新規追加
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeButtonClickEvent">
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 公共事業場検索 -->
    <public-place-search-modal
      :dialog="searchPublicPlace"
      :target-item="selectableItem"
      :target-selectable-ids="selectableIds"
      :searched-at="searchedAt"
      @closeCallback="closeModalCallback"
      @registerCallback="publicPlaceSearchCallback"
    />
    <!-- /公共事業場検索 -->

    <!-- 公共事業場新規登録 -->
    <public-place-add-modal
      :dialog="addPublicPlace"
      :target-manifest-id="selectableManifestId"
      :target-id="selectableId"
      :target-selectable-ids="selectableIds"
      :searched-at="searchedAt"
      @closeCallback="closeModalCallback"
      @registerCallback="publicPlaceSearchCallback"
    />
    <!-- /公共事業場新規登録 -->
  </div>
</template>
